var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 21 20",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4d4d4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.7969 3.00781v3.39453c0 .23012.1865.41668.4167.41668h4.0728",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7626 17.0746h-5.57346c-.23013 0-.41668-.1866-.41668-.4167v-13.36622c0-.23013.18655-.41668.41668-.41668h7.84176c.1045 0 .2052.03927.2821.11003l3.8599 3.55114c.0857.0789.1345.19011.1345.30664v3.45849",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.3332 15.0057c.2511 0 .4566-.2046.4566-.4551 0-.2506-.2055-.4552-.4566-.4552h-2.0434v-2.0357c0-.2506-.2055-.4552-.4566-.4552s-.4567.2046-.4567.4552v2.0357h-2.0433c-.2511 0-.4567.2046-.4567.4552 0 .2505.2056.4551.4567.4551h2.0433v2.0357c0 .2506.2056.4552.4567.4552s.4566-.2046.4566-.4552v-2.0357z",
    fill: "#4d4d4d",
    strokeWidth: 0.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.528a576609ab23e82156964ec861580f.svg";
export { ForwardRef as ReactComponent };